import React from 'react'
import styled from 'styled-components'
import { useGlobalLabels } from '@sentecacommerce-theme/lib'
import { Controller } from 'react-hook-form'
import { FormError, Input, InputLabel as Label } from '../..'
import { Checkbox } from '../../Checkbox'

type BillingAddressProps = {
  errors: any
  control: any
}

export type BillingAddressFormData = {
  company: string
  uic: string
  mol: string
  companyAddress: string
  vatNumber: string
  isDefaultBillingAddress: boolean
  companyPerson: string
}

export const BillingAddressForm = ({
  errors,
  control,
}: BillingAddressProps) => {
  const { company, globalValidations, address } = useGlobalLabels()
  return (
    <div>
      <Title>{company?.companyData}</Title>
      <RequiredFields>{globalValidations?.requiredFields}</RequiredFields>

      <InputsWrapper>
        <DesktopHalf>
          <Label htmlFor="billing-address-first-name">
            {`${company?.companyName} *`}
            <Controller
              control={control}
              name="company"
              rules={{
                required: globalValidations?.fieldIsRequired,
              }}
              as={<Input id="billing-address-first-name" />}
            />
            <FormError errors={errors} fieldName="company" />
          </Label>
        </DesktopHalf>
        <DesktopHalf>
          <Label htmlFor="billing-address-person">
            {`${company?.mol} *`}
            <Controller
              control={control}
              name="companyPerson"
              rules={{
                required: globalValidations?.fieldIsRequired,
              }}
              as={<Input id="billing-address-person" />}
            />
            <FormError errors={errors} fieldName="companyAddress" />
          </Label>
        </DesktopHalf>
        <DesktopHalf>
          <Label htmlFor="billing-address-vatNumber">
            {`${company?.vat} *`}
            <Controller
              control={control}
              name="vatNumber"
              rules={{
                required: globalValidations?.fieldIsRequired,
              }}
              as={<Input id="billing-address-vatNumber" />}
            />
            <FormError errors={errors} fieldName="vatNumber" />
          </Label>
        </DesktopHalf>
        <DesktopHalf>
          <Label htmlFor="billing-address-uic">
            {`${company?.companyId} *`}
            <Controller
              control={control}
              name="uic"
              rules={{
                required: globalValidations?.fieldIsRequired,
              }}
              as={<Input id="billing-address-uic" />}
            />
            <FormError errors={errors} fieldName="uic" />
          </Label>
        </DesktopHalf>
        <DesktopHalf>
          <Label htmlFor="billing-address-address">
            {`${address?.label} *`}
            <Controller
              control={control}
              name="companyAddress"
              rules={{
                required: globalValidations?.fieldIsRequired,
              }}
              as={<Input id="billing-address-address" />}
            />
            <FormError errors={errors} fieldName="companyAddress" />
          </Label>
        </DesktopHalf>
        <div className="col-12">
          <Label className="pt-4" htmlFor="billing-isDefaultBillingAddress">
            <Controller
              control={control}
              name="isDefaultBillingAddress"
              render={({ value, onChange }) => {
                return (
                  <Checkbox
                    name="isDefaultBillingAddress"
                    isChecked={value}
                    label={company?.saveAsDefault}
                    small
                    onChange={() => onChange(!value)}
                  />
                )
              }}
            />
            <FormError errors={errors} fieldName="isDefaultBillingAddress" />
          </Label>
        </div>
      </InputsWrapper>
    </div>
  )
}

const InputsWrapper = styled.div.attrs({
  className: 'row',
})``

const DesktopHalf = styled.div.attrs({
  className: 'col-12 col-lg-6',
})``

const Title = styled.h6.attrs({
  className: 'mb-3',
})<{ paddingTop?: boolean }>`
  padding-top: ${(props) => (props.paddingTop ? '1.5rem' : 0)};
`

const RequiredFields = styled.p.attrs({
  className: 'mb-4',
})`
  color: ${({ theme }) => theme.palette.hint};
`
